<template>
	<div class="account">
		<div class="account-info">
			<div class="account-bg account-info-top">
				<div class="setting" @click="handleSet">
					<img src="../../../assets/images/account/set.png" />
				</div>
			</div>
			<div class="account-info-bottom">
				<van-uploader :before-read="beforeRead" :after-read="afterRead">
					<div class="avtar">
						<van-loading v-if="uploadLoading" class="uploadLoading" size="20px" vertical color="#1989fa">上传中...</van-loading>
						<img :src="userInfo.headImage || require('../../../assets/images/account/userdefault.png')" alt="" />
					</div>
				</van-uploader>
				<div class="name">
					{{ userInfo.nickname }}
				</div>
			</div>
		</div>
		<div class="account-content">
			<div class="info-entry">
				<template v-if="configArr.is_show_my_learning_data">
					<div class="info-item flex-space-between assessment" @click="handleAssess">
						<div class=" align-items-center">
							<svg-icon icon-class="account-assess-icon" class-name="account-icon"></svg-icon>
							<div>
								<p class="">学习报告</p>
							</div>
						</div>
						<div class="info-item-right">
							<div class="align-items-center assessment">
								<p>
									累计学习时长<span class="totalLearnTime">{{ totalLearnTime }}</span
									>小时
								</p>
							</div>
							<van-icon name="arrow" />
						</div>
					</div>
					<div class="line"></div>
				</template>
				<template v-if="configArr.is_show_my_certificate">
					<div class="info-item flex-space-between" @click="handleCertificate">
						<div class=" align-items-center">
							<svg-icon icon-class="account-certificate-icon" class-name="account-icon"></svg-icon>
							<div>
								<p class="">我的证书</p>
							</div>
						</div>
						<div class="info-item-right">
							<van-icon name="arrow" />
						</div>
					</div>
					<div class="line"></div>
				</template>
				<template v-if="configArr.is_show_my_profile">
					<div class="info-item flex-space-between" @click="$router.push({ path: '/myProfile_new' })">
						<div class=" align-items-center">
							<svg-icon icon-class="account-info-icon" class-name="account-icon"></svg-icon>
							<div>
								<p class="">我的资料</p>
							</div>
						</div>
						<div class="info-item-right">
							<van-icon name="arrow" />
						</div>
					</div>
					<div class="line"></div>
				</template>

				<template v-if="configArr.is_show_my_order">
					<div class="info-item flex-space-between" @click="handlePay">
						<div class=" align-items-center">
							<svg-icon icon-class="account-order-icon" class-name="account-icon"></svg-icon>
							<div>
								<p class="">我的订单</p>
							</div>
						</div>
						<div class="info-item-right">
							<van-icon name="arrow" />
						</div>
					</div>
					<div class="line"></div>
				</template>
				<template v-if="configArr.is_show_my_evaluation">
					<div class="info-item flex-space-between margin-btm ic_setting_aboutus" @click="$router.push({ path: '/testreport' })">
						<div class=" align-items-center">
							<svg-icon icon-class="account-evaluation-icon" class-name="account-icon"></svg-icon>
							<div>
								<p class="">我的测评</p>
							</div>
						</div>
						<div class="info-item-right">
							<van-icon name="arrow" />
						</div>
					</div>
				</template>
				<!-- 一键实施demo不需要展示身份认证 -->
				<template>
					<div v-if="!isWdDemo" class="info-item flex-space-between ic_mine_class" @click="handleIden">
						<div class=" align-items-center">
							<svg-icon icon-class="account-registration-icon" class-name="account-icon"></svg-icon>
							<div>
								<p class="">身份认证</p>
							</div>
						</div>
						<div class="info-item-right">
							<div v-if="+userInfo.idAuthStatus === 1" class="align-items-center">
								<p class="authTag">
									<img src="../../../assets/images/account/auth.png" alt="" />
									<span class="">已实名</span>
								</p>
							</div>
							<div v-else>
								<span>未实名</span>
							</div>
							<van-icon name="arrow" />
						</div>
					</div>
					<div class="line"></div>
				</template>

				<template>
					<div class="info-item flex-space-between ic_setting_aboutus" @click="$router.push('personAccount_new')">
						<div class=" align-items-center">
							<svg-icon icon-class="account-security-icon" class-name="account-icon"></svg-icon>
							<div>
								<p class="">账号安全</p>
							</div>
						</div>
						<div class="info-item-right">
							<van-icon name="arrow" />
						</div>
					</div>
					<div class="line"></div>
				</template>
				<template>
					<div class="info-item flex-space-between ic_setting_aboutus" @click="handleAbout">
						<div class=" align-items-center">
							<svg-icon icon-class="account-about-icon" class-name="account-icon"></svg-icon>
							<div>
								<p class="">关于我们</p>
							</div>
						</div>
						<div class="info-item-right">
							<van-icon name="arrow" />
						</div>
					</div>
				</template>
				<template>
					<div class="info-item flex-space-between ic_setting_aboutus" @click="goMessage">
						<div class=" align-items-center">
							<svg-icon icon-class="account-message-icon" class-name="account-icon"></svg-icon>
							<div class="user-message">
								<p class="">我的消息</p>
								<span :class="showUnread ? 'dot' : ''"></span>
							</div>
						</div>
						<div class="info-item-right">
							<van-icon name="arrow" />
						</div>
					</div>
				</template>
			</div>
		</div>
		<face1 v-if="authShow" @toggle="toggle"></face1>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import face1 from '../../../layout/faceauth'
export default {
	name: 'personalCenter',
	data() {
		return {
			uploadLoading: false,
			configArr: {
				is_show_my_learning_data: true, // 学习报告
				is_show_my_profile: true, //我的资料(目前只有军民、民政显示)
				is_show_my_certificate: true,
				is_show_my_task: true,
				is_show_my_study: true,
				is_show_my_order: true,
				is_show_my_evaluation: true,
			},
			totalLearnTime: 0,
			authShow: false,
			about_us_config: null,
			showUnread: false,
			isWdDemo: false, //是否是一键实施demo,一键实施不需要展示身份认证
		}
	},
	mounted() {
		const frontendConfig = this.$store.state.dynamic.frontendConfig || []
		this.about_us_config =
			frontendConfig.length &&
			frontendConfig.filter((item) => {
				if (item.key === 'about_us_config') {
					return true
				}
			})[0]
	},
	components: {
		face1,
	},
	computed: {
		...mapState(['userInfo']),
	},
	created() {
		//是否是一键实施demo
		this.isWdDemo = localStorage.getItem('isWdDemo')
		this.existUnread()
		this.getSaasTree()
		this.initConfig()
		this.getAllLearnedData()
	},
	methods: {
		beforeRead(file) {
			this.uploadLoading = true
			if (file.type.indexOf('image') === -1) {
				this.$notify({ duration: 2000, type: 'danger', message: '请上传正确格式的图片' })
				this.uploadLoading = false
				return false
			}
			return true
		},
		afterRead(file) {
			// 此时可以自行将文件上传至服务器
			let formData = new FormData()
			formData.append('file', file.file)
			this.$api.user
				.upload(formData)
				.then(async (res) => {
					if (res.code == 0) {
						// 保存头像
						try {
							let result = this.$api.user.updateUser({ headImage: res.data })
							if (result) {
								this.$store.commit('setUserInfo', { headImage: res.data })
								this.uploadLoading = false
							}
						} catch (error) {
							this.uploadLoading = false
						}
					}
				})
				.catch((err) => {
					this.uploadLoading = false
				})
		},
		//获取城市列表
		// getTree(){
		//     if(sessionStorage.getItem('areaList')) return
		//     return this.$api.usercenter.getTree().then(res => {
		//         let areaText = []
		//         let newData = []
		//         newData = res.data.filter((item) => {
		//             return item.code.length == 2
		//         })
		//         newData.forEach(item => {
		//             const L1Name = item.name
		//             item.text = item.name
		//             item.children && item.children.length && item.children.forEach(el => {
		//                 const L2Name = el.name
		//                 el.text = el.name
		//                 if(!el.children){
		//                     areaText.push({
		//                         name: `${L1Name}/${L2Name}`,
		//                         code: el.code,
		//                         id: el.id
		//                     })
		//                 }else if(el.children.length){
		//                     el.children.forEach(v => {
		//                         const L3Name = v.name
		//                         v.text = v.name
		//                         areaText.push({
		//                             name: `${L1Name}/${L2Name}/${L3Name}`,
		//                             code: v.code,
		//                             id: v.id
		//                         })
		//                     })
		//                 }
		//             })
		//         })
		//         sessionStorage.setItem('areaTextAndCode',JSON.stringify(areaText))
		//         sessionStorage.setItem('areaList',JSON.stringify(newData))
		//     })
		// },
		//获取城市列表
		getSaasTree() {
			if (sessionStorage.getItem('areaList')) return
			// var personalUserInfo = localStorage.getItem('personalUserInfo')?JSON.parse(localStorage.getItem('personalUserInfo')):{}
			// var saasId=personalUserInfo.saasId
			return this.$api.usercenter.findSaasIdList().then((res) => {
				let newData = []
				let areaText = []
				var totalData = res.data
				totalData.forEach((item) => {
					areaText.push({
						name: item.name,
						code: item.code,
					})
					newData.push(item.name)
				})
				sessionStorage.setItem('areaTextAndCode', JSON.stringify(areaText))
				sessionStorage.setItem('areaList', JSON.stringify(newData))
			})
		},
		initConfig() {
			let configArr = this.$store.state.dynamic.frontendConfig || []
			configArr.length &&
				configArr.forEach((item) => {
					switch (item.key) {
						case 'is_show_my_learning_data':
							this.configArr[item.key] = item.value === 'false' ? false : true
							break
						case 'is_show_my_profile':
							this.configArr[item.key] = item.value === 'false' ? false : true
							break
						case 'is_show_my_certificate':
							this.configArr[item.key] = item.value === 'false' ? false : true
							break
						case 'is_show_my_task':
							this.configArr[item.key] = item.value === 'false' ? false : true
							break
						case 'is_show_my_study':
							this.configArr[item.key] = item.value === 'false' ? false : true
							break
						case 'is_show_my_order':
							this.configArr[item.key] = item.value === 'false' ? false : true
							break
						case 'is_show_my_evaluation':
							this.configArr[item.key] = item.value === 'false' ? false : true
							break
						default:
							break
					}
				})
		},
		toggle(val) {
			this.authShow = val
		},
		onClickLeft() {
			this.$router.go(-1)
		},
		getAllLearnedData() {
			this.$api.myassessment.getAllLearnedData().then((res) => {
				this.totalLearnTime = res.data.totalLearnTime
			})
		},
		handlePay() {
			this.$router.push({
				path: '/orderpage',
			})
		},
		handleCertificate() {
			var certificateLocalUrl = window.location.href
			sessionStorage.setItem('certificateLocalUrl', window.location.href)
			this.$router.push({
				path: '/certificate',
			})
		},
		handleAbout() {
			if (this.about_us_config && this.about_us_config.value) {
				this.$router.push({
					path: this.about_us_config.value,
				})
			} else {
				this.$router.push({
					path: '/about',
				})
			}
		},
		// 前往站内消息
		goMessage() {
			this.$router.push({
				path: '/userMessageList',
			})
		},
		handleAssess() {
			this.$router.push({
				path: '/assess',
			})
		},
		handleSet() {
			this.$router.push({
				path: '/setting_new',
			})
		},
		handleIden() {
			if (this.userInfo.idAuthStatus == 1) {
				this.$router.push({
					path: '/identification',
				})
			} else {
				this.$router.push('/idcard')
			}
		},
		// 查询用户是否有未读消息
		async existUnread() {
			let result = await this.$api.userMessage.existUnread()
			if (result.success) {
				this.showUnread = result.data
			}
		},
	},
}
</script>
<style lang="stylus" scoped>
.account{
    min-height 100vh
    padding-bottom 100px
    background #F5F6FA
    box-sizing border-box
}
    .flex-space-between{
        display :flex;
        justify-content:space-between;
        align-items :center;
    }
    .align-items-center{
        display :flex;
        align-items :center;

    }
    .assessment
        font-size 26px
        color #666
        letter-spacing 1px
        // margin-right 16px
        .totalLearnTime {
            color #3760FF
        }
    .account-info{
        .account-info-top{
            height :300px;
            background:url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/account/setbg.png') no-repeat center center;
            background-size:cover;
            position:relative;
            .setting{
                width:40px;
                height :45px;
                background:ur;
                position :absolute;
                top:30px;
                right:30px;
                img{
                    width:100%;
                }
            }
        }
        .account-info-bottom{
            margin-top :-111px;
            text-align :center;
            position :relative;
            .avtar{
                position relative
                width 160px
                height 160px
                margin:0 auto;
                border-radius:50%;
                // margin-bottom :36px;
                overflow:hidden;
                .uploadLoading {
                    position absolute
                    left 0
                    right 0
                    top 0
                    bottom 0
                    background-color rgba(255,255,255,.6)
                    border-radius 50%
                    text-align center
                    /deep/ .van-loading__spinner {
                        margin-top 25px
                    }
                }
                img{
                    width:100%;
                    height:100%;
                }
            }
            .name {
                font-size 36px
                font-weight: bold
                color #000
                margin-top 40px
            }
            p{
                font-size:36px;
                line-height :36px;
                color :#000000;
                font-weight:500;
            }
        }
    }
    .account-content{
        padding:40px;
        .info-entry {
            position relative
            .line {
                width: 580px;
                height: 1px;
                background: #E4E5E6;
                position absolute
                right 0
            }
            .border{
                border-radius: 0.32rem;
            }
        }
        .account-info-top{
            height 300px;
            background:#ccc;
        }
        .assess{
            height 118px;
            padding:53px 30px 53px 45px;
            background: #FFFFFF;
            box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.08);
            border-radius: 24px;
            margin-bottom :40px;
            .assess-left{
                img{
                    width:130px;
                    height:130px;
                    margin-right :30px;
                }
                .assess-left-title{
                    color :#000000;
                    font-size:36px;
                    line-height :36px;
                    margin-bottom :20px;
                    font-weight:500;
                }
                .assess-left-content{
                    color:#666666;
                    font-size:26px;
                    line-height :26px;
                }
            }
            .assess-right{
                i{
                    color:#999999;
                    font-size:24px;
                }
                p{
                    color:#999;
                }
            }
        }
        .info-item{
            font-size :30px;
            line-height :30px;
            color:#3E414E;
            padding:37px 30px;
            background:#fff;
            &.assessment{
                //  margin-bottom 40px
                 margin-right 0
                border-top-left-radius 12px
                border-top-right-radius 12px
            }
            &.margin-btm {
                margin-bottom 40px
            }
            &.ic_mine_class {
                border-top-left-radius 12px
                border-top-right-radius 12px
            }
            &.ic_setting_aboutus {
                border-bottom-left-radius 12px
                border-bottom-right-radius 12px
            }
            img{
                width:44px;
                height:44px;
                margin-right:20px;
            }
            .account-icon{
                font-size: 44px;
                margin-right: 20px;
            }
            .info-item-right{
                display :flex;
                align-items :center;
                color:#9197AE;
                font-size :24px;
                .authTag{
                    color:#FFA302;
                    font-size:22px;
                    border:1px solid #FFA302;
                    border-radius:4px;
                    margin:0 10px;
                    padding:4px 6px;
                    img{
                        width:18px;
                        height:19px;
                        margin-right :5px;
                    }
                }
                .right-arrow{
                    margin-left :10px;
                }
            }
        }
    }
    .user-message
        display flex
        align-items center
        .dot
            width 14px
            height 14px
            border-radius 50%
            background: #FF4C4C;
            margin-left 10px
</style>
